<div class="ionic ionic-example">
  <div class="bar bar-header bar-dark">
    <h1 class="title">{{'ContactAddress' | translate}}</h1>
  </div>
</div>
<ion-row>
  <ion-col size="3" text-bold>{{'FirstName' | translate}}</ion-col>
  <ion-col size="9"><edit-input [isEdit]="isEdit" [modelData]="contractData.firstname" (modelDataOut)="changeData('firstname',$event)"></edit-input></ion-col>
</ion-row>
<ion-row>
  <ion-col size="3" text-bold>{{'LastName' | translate}}</ion-col>
  <ion-col size="9"><edit-input [isEdit]="isEdit" [modelData]="contractData.lastname" (modelDataOut)="changeData('lastname',$event)"></edit-input></ion-col>
</ion-row>
<ion-row>
  <ion-col size="3" text-bold>{{'Address' | translate}}</ion-col>
  <ion-col size="9"><edit-input [isEdit]="isEdit" [modelData]="contractData.street" (modelDataOut)="changeData('street',$event)"></edit-input></ion-col>
</ion-row>
<ion-row>
  <ion-col size="3" text-bold>{{'Zip' | translate}}/{{'City' | translate}}</ion-col>
  <ion-col size="9"><edit-input [isEdit]="isEdit" [modelData]="contractData.zip" (modelDataOut)="changeData('zip',$event)"></edit-input> <edit-input [isEdit]="isEdit" [modelData]="contractData.city" (modelDataOut)="changeData('city',$event)"></edit-input></ion-col>
</ion-row>
<ion-row>
  <ion-col size="3" text-bold>{{'Country' | translate}}</ion-col>
  <ion-col size="9"><edit-input [isEdit]="isEdit" [modelData]="contractData.country" (modelDataOut)="changeData('country',$event)"></edit-input></ion-col>
</ion-row>
<fieldset>
  <legend>{{'Comment' | translate}}</legend>
  <edit-input [isEdit]="isEdit" type="textarea" [modelData]="contractData.info" (modelDataOut)="changeData('info',$event)"></edit-input>
</fieldset>
